// Official Asaas trust seal, per their integration playbook. The `id` query param is issued
// per-account by Asaas support — REACT_APP_ASAAS_SEAL_ID must be set to the production id before
// go-live; the fallback below is the vendor's homologation example and is not valid in prod.
const ASAAS_SEAL_ID = process.env.REACT_APP_ASAAS_SEAL_ID || "42305ad2-aa00-456b-a451-5c1f640ca16e";
const ASAAS_SEAL_URL = `https://baas.asaas.com/selos/Servicos_financeiros_Asaas-Reduzida-Positivo.svg?id=${ASAAS_SEAL_ID}`;

const SIZES = {
    sm: { width: 130, height: 39 },
    md: { width: 160, height: 48 },
};

const AsaasSeal = ({ size = "sm", className = "" }) => {
    const { width, height } = SIZES[size] || SIZES.sm;

    return (
        <a
            href="https://asaas.com"
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-block ${className}`}
        >
            <img
                src={ASAAS_SEAL_URL}
                alt="Selo Banco Asaas"
                width={width}
                height={height}
                style={{ display: "inline-block" }}
            />
        </a>
    );
};

export default AsaasSeal;
